import { render, staticRenderFns } from "./toDoNewDetail.vue?vue&type=template&id=79d87a1b&scoped=true&"
import script from "./toDoNewDetail.vue?vue&type=script&lang=js&"
export * from "./toDoNewDetail.vue?vue&type=script&lang=js&"
import style0 from "./toDoNewDetail.vue?vue&type=style&index=0&id=79d87a1b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d87a1b",
  null
  
)

export default component.exports